export const columns = [
    { field: 'id', headerName: 'ID', flex: 1, minWidth: 200 },
    { field: 'name', headerName: 'Название раздела', flex: 3, minWidth: 200 },
];

export const rows = [
    {
        id: 1,
        chapterName: 'Буровые установки'
    },
    {
        id: 2,
        chapterName: 'Буровые установки'
    },
    {
        id: 3,
        chapterName: 'Буровые установки'
    },
    {
        id: 4,
        chapterName: 'Буровые установки'
    },
    {
        id: 5,
        chapterName: 'Буровые установки'
    },
    {
        id: 6,
        chapterName: 'Буровые установки'
    },
]